import Select, { Props } from "react-select";

export const SelectComponent = (props: Props) => {
  return <Select {...props} />;
};
